import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=08b2976d&scoped=true"
import script from "./AudioUpload.vue?vue&type=script&lang=js"
export * from "./AudioUpload.vue?vue&type=script&lang=js"
import style0 from "./AudioUpload.vue?vue&type=style&index=0&id=08b2976d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2976d",
  null
  
)

export default component.exports